import $x from '@/utils/$x';

const cacheStore = new Map();
const TTL = 5 * 60 * 1000;

function cacheKey(path, params) {
  return `${path}::${JSON.stringify(params || {})}`;
}

function setCache(key, value) {
  cacheStore.set(key, { value, time: Date.now() });
}

function getCache(key) {
  const entry = cacheStore.get(key);
  if (!entry) return null;
  if (Date.now() - entry.time > TTL) {
    cacheStore.delete(key);
    return null;
  }
  return entry.value;
}

function normalizeEmpty(value) {
  if (value === '') return null;
  if (Array.isArray(value)) return value.map((v) => normalizeEmpty(v));
  if (value && typeof value === 'object') {
    const next = {};
    Object.keys(value).forEach((k) => {
      next[k] = normalizeEmpty(value[k]);
    });
    return next;
  }
  return value;
}

export async function getHealthHabitIndicators(params) {
  const path = '/healthHabit/indicators';
  const key = cacheKey(path, params);
  const cached = getCache(key);
  if (cached) return cached;
  const res = await $x.post(path, params);
  const normalized = {
    ...res,
    data: normalizeEmpty(res?.data),
  };
  setCache(key, normalized);
  return normalized;
}

export async function getHealthHabitIndex(params) {
  const path = '/healthHabit/index';
  const key = cacheKey(path, params);
  const cached = getCache(key);
  if (cached) return cached;
  const res = await $x.post(path, params);
  const normalized = {
    ...res,
    data: normalizeEmpty(res?.data),
  };
  setCache(key, normalized);
  return normalized;
}

